import { render, staticRenderFns } from "./IotAlertWhitelistList.vue?vue&type=template&id=09635782&scoped=true&"
import script from "./IotAlertWhitelistList.vue?vue&type=script&lang=js&"
export * from "./IotAlertWhitelistList.vue?vue&type=script&lang=js&"
import style0 from "./IotAlertWhitelistList.vue?vue&type=style&index=0&id=09635782&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09635782",
  null
  
)

export default component.exports